import en from './en.json'
import it from './it.json'

export const sendingTranslations = {
	en,
	it
} as const
